import axios from "axios";

/**
 * DETECCIÓN AUTOMÁTICA DE ENTORNO
 */
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const serverUrl = isLocal ? 'http://localhost:8000' : window.location.origin;

const baseUrl = `${serverUrl}/api/v1`;

/**
 * FUNCIÓN AUXILIAR PARA CABECERAS (TOKEN)
 */
const getAuthConfig = () => {
    const token = localStorage.getItem('access_token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };
};

// --- CURSO ACTIVO ---
export const getCourseActive = async (context, id) => {
    try {
        const res = await axios.get(`${baseUrl}/public/course/details/${id}`)
        const { data } = res.data
        context.commit("SET_COURSE_ACTIVE", data)
        return { ok: true, data }
    } catch (error) {
        return { ok: false }
    }
}

// --- TEMARIO DEL CURSO ---
export const getCourse = async (context, slug) => {
    await axios.get(`${baseUrl}/public/course/temary/get-all-class/${slug}`).then(
        (res) => {
            context.commit("SET_COURSE", res.data)
            context.commit("listId_NameClass", res.data)
        }
    )
}

// --- CLASE ACTUAL ---
export const getLesson = (context, less) => {
    context.commit("SET_LESSON", less)
}

// --- ÚLTIMA CLASE VISTA ---
export const lastSeenLesson = async (_, { course_id, class_id }) => {
    if (!course_id || !class_id) return
    try {
        await axios.patch(`${baseUrl}/purchased/save-class-seen?course_id=${course_id}&class_id=${class_id}`, {}, getAuthConfig())
        return { ok: true }
    } catch (error) {
        return { ok: false }
    }
}

export const getExam = async (context, examId) => {
    try {
        const respuesta = await axios.get(`${baseUrl}/course/exam?exam_id=${examId}`, getAuthConfig());
        context.commit('DATA_EX', respuesta.data); 
        return respuesta;
    } catch (error) {
        console.error("Error en getExam:", error.response ? error.response.data : error);
        throw error;
    }
}

export const sendAnswersExamen = async (_, { id_exam, answers, course_id, seconds_used }) => {
    try {
        const resp = await axios.post(`${baseUrl}/course/exam/answers`, { 
            id_exam, 
            answers, 
            course_id, 
            seconds_used 
        }, getAuthConfig());
        return { ok: true, resp: resp.data };
    } catch (error) {
        console.error("Error al enviar respuestas:", error);
        return { ok: false };
    }
}

// --- VIDEO ---
export const getVideo = async (context, classId) => {
    await axios.get(`${baseUrl}/video/stream-video?class_id=${classId}`, getAuthConfig()).then(
        (res) => {
            context.commit('SET_VIDEO', res.data);
        }
    );
}

// --- VALORACIÓN ---
export const getRating = async (context, id) => {
    await axios.get(`${baseUrl}/course/rate/show/${id}`)
        .then((res) => {
            context.commit('GET_RATING', res.data);
        })
}

export const setRating = async ({ commit }, comment) => {
    try {
        const resp = await axios.post(`${baseUrl}/course/rate/store`, comment, getAuthConfig())
        if (resp.data.status === 200) {
            commit('setRating', comment)
        }
    } catch (error) {
        throw new Error(error)
    }
}